import { JSX } from 'react'

import { IconProps } from '../../icon'

const Literatura: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M11.9595 31.759C11.0083 31.759 10.2298 31.1182 10.2298 30.3352V26.5292C10.2298 25.7462 11.0083 25.1055 11.9595 25.1055H38.6623C38.6623 25.1055 37.9415 26.595 37.9415 28.4322C37.9415 30.2695 38.845 31.759 39.9595 31.759H11.9595Z'
      fill='#AAD3DC'
    />
    <path
      d='M11.9595 23.543C11.0083 23.543 10.2298 22.9205 10.2298 22.1598V19.8453C10.2298 19.0845 11.0083 18.462 11.9595 18.462H33.9055C33.9055 18.462 33.6173 19.5633 33.6173 21.3483C33.6173 23.1333 34.5208 23.543 35.6353 23.543H11.9595Z'
      fill='#D7D861'
    />
    <path
      d='M18.3018 35.5068L16.1395 33.777L13.9773 35.5068V28.4558H18.3015V35.5068H18.3018ZM38.6623 17.0565C37.5478 17.0565 37.0808 16.1195 37.0808 15.074C37.0808 13.404 37.5633 13.597 37.5633 13.597H10.8603C9.36475 13.597 8.93225 14.1793 8.93225 14.891V15.7623C8.93225 16.474 9.71075 17.0563 10.662 17.0563H38.6623V17.0565Z'
      fill='#F9D865'
    />
    <path
      d='M18.7345 36.4065L16.14 34.331L13.5455 36.4065V32.1915H11.9597C10.7675 32.1915 9.7975 31.2215 9.7975 30.0293V25.4055C9.7975 24.699 10.1382 24.0705 10.6637 23.6757C10.1385 23.281 9.7975 22.6525 9.7975 21.946V18.7863C9.7975 18.2828 9.97025 17.8193 10.26 17.4513C9.25925 17.262 8.5 16.3812 8.5 15.3267V14.1623C8.5 12.97 9.47 12 10.6623 12H39.2027V12.8647H38.679C38.5193 12.8802 37.5088 13.0445 37.5088 14.7442C37.5088 16.4443 38.5198 16.6087 38.6793 16.624H39.2025V17.4887H35.635C34.9285 17.4887 34.0492 17.4887 34.0492 20.2995C34.0492 22.5702 35.4237 23.1497 35.6992 23.243H40.5V24.1077H39.9595C39.2095 24.1077 38.3738 25.59 38.3738 27.717C38.3738 29.844 39.2095 31.3265 39.9595 31.3265H40.5V32.1912H18.7345V36.4065ZM17.8695 31.3268V28.8882H14.41V31.3268V32.1915V34.607L16.1398 33.2233L17.8695 34.607V32.1915V31.3268ZM18.7345 31.3268H38.4937C37.8925 30.519 37.509 29.215 37.509 27.7172C37.509 26.2197 37.8925 24.916 38.4937 24.108H11.9595C11.2443 24.108 10.6623 24.69 10.6623 25.4052V30.0293C10.6623 30.7445 11.2443 31.3265 11.9595 31.3265H13.5452V28.0233H18.7345V31.3268ZM11.9595 17.4887C11.2443 17.4887 10.6623 18.0708 10.6623 18.786V21.9458C10.6623 22.661 11.2443 23.243 11.9595 23.243H34.191C33.6647 22.6783 33.1847 21.7622 33.1847 20.2995C33.1847 18.9985 33.3608 18.0815 33.7533 17.4887H11.9595ZM10.6623 12.865C9.947 12.865 9.365 13.447 9.365 14.1623V15.3267C9.365 16.042 9.947 16.624 10.6623 16.624H37.1623C36.86 16.201 36.644 15.5942 36.644 14.7442C36.644 13.8942 36.8598 13.2877 37.1623 12.8647H10.6623V12.865Z'
      fill='black'
    />
  </svg>
)

export default Literatura
